import React from "react";
import { useEffect } from "react";
import Abouthero from "../../components/about/aboutHero";
import Education from "../../components/about/Education";
import Experience from "../../components/about/workExp";
const About = () => {
    useEffect(()=>{
        document.title ="Udoka | About"
})
    return ( 
        <div className="py-4 px-2 md:px-4">
<Abouthero/>
<Education/>
<Experience/>
        </div>
     );
}
 
export default About;